import grapesjs from "grapesjs";
import gjsBlockBasic from "grapesjs-blocks-basic";
import grapesJsexportPlugin from "grapesjs-plugin-export";
import grapesJsFormsPlugin from "grapesjs-plugin-forms";
import gjsTabs from "../../components/ComponentsTabs/index.js";
import gjsTable from "grapesjs-table";
//import gjsForm from "grapesjs-plugin-forms";
import "../../css/editor.scss";
import "../../css/grapesjs.scss";
import UnlockIcon from "../../images/unlock-icon-toolbar.svg";
import LockIcon from "../../images/lock-icon-toolbar.svg";
import { moduleApiEndPoint, moduleApiEndPointV2 } from "../../services/axiosConfig";
import {
  defaultBlocks,
  styleManager,
  blocks,
  thirdPartyPlugins,
  script,
  mandatScript,
} from "../../utils/editorUtils/editorUtils";
import { ExportDeckToMail, getFontlist } from "../../services/apis";
import { cutomTraitsLinkPlugin } from "./customLinkBlock/cutomTraitsLinkPlugin.js";
import { attachMasterSlide } from "./customScriptBlock.js"
import { gereratePluginsList } from "./generatePluginsList.js"
import { EditorOnLoad } from "./EditorOnLoad.js"
import { UpdateHTMLForAllRatios } from "./ResponsiveFunctions.js"
import { showErrorToast, showSuccessToast } from "../../components/toastComponent/ToastComponent.js";
import { callbackOnDeselectOfComp, defaultConfigForAllComp, hideGeneralAndTopographyForWrapper, leftPanelBlocksHideShow, linkComponent, hideModularContentForBodyTag, modularContentToggleShow, onCompSelectConfig, opacityFieldRestrictDecimal, removeCompSettingRetainDefault, removePopupDivLinkedToComp, tableConfig, tableRowColumnDecimalRestriction, trackDroppingComponent, videoConfig,symbolRestrictModify } from "../editorUtils/componentConfig.js"
import { customTigger } from "./customPopup/CustomTrigger.js"
import { aspectRatioCheckBoxHandler } from "./aspectRatio.js";
import { keycloak } from "../../services/keycloak.js";
import { mustUseRemove } from "./mustUseRemove.js";
import { syncSelectedModuleUsedFromCanvas } from "./syncSelectedModuleUsedFromCanvas.js";
import { isResponsiveStyleStoragePropKey, stripResponsiveStyleGroupFromCssRow } from "./responsiveCssManager.js";
let plugList = [];
let Flag = false
function getGrapeJsEditor({
  currentSlideRef,
  setState,
  setVideoSelected,
  setShowPreView,

  setSaveLoading,
  setLoading,
  setLoadSuccess,
  setExportLoading,

  showSlidesPanel,

  setOpenExportModal,
  localLink,
  switchToggleDataRef,
  setUndoCurrentStatus,
  setRedoCurrentStatus,
  setReferenceBetween,

  setAddReferenceBlock,
  setUploadFont,
  appData,
  setOpenDocumentModal,
  setExpandRight,
  setExpandLeft,
  selectedItem,
  setCSSState,
  cssRef,
  storageObjRef,
  setStorageObj,
  listOfIDRef,
  setListOfID,
  codeEditor,
  setDimensionVariable,
  relatedClaimsDataRef,

}) {
  let cssLink = [];
  if (localStorage.getItem('cssglobalUrl')) {
    cssLink.push(localStorage.getItem('cssglobalUrl'))
  } else {
    cssLink.push(appData?.deckId?.deck_shared_assets?.global?.css?.url)
  }


  if (!plugList.length)
    plugList = gereratePluginsList()

  // if (isOpenPanel) {
  if (
    document.getElementById("blocks") ||
    document.getElementById("stylesMangerBlock") ||
    document.getElementById("editor-actions-btns") ||
    document.getElementById("traitBlock") ||
    document.getElementById("layerHtml")

  ) {
    document.getElementById("blocks").innerHTML = "";
    document.getElementById("stylesMangerBlock").innerHTML = "";
    document.getElementById("editor-actions-btns").innerHTML = "";
    document.getElementById("traitBlock").innerHTML = "";
    document.getElementById("layerHtml").innerHTML = "";

  }
  const blockContainer = document?.querySelector("#blocks");
  const styleContainer = document?.querySelector("#stylesMangerBlock");
  const traitsContainer = document?.querySelector("#traitBlock");
  const backtoBlockSection = document?.querySelector("#backToBlocks");

  let IDRef =
    JSON.stringify(currentSlideRef?.current?.child) === "{}"
      ? currentSlideRef?.current?.master?.slideid?._id
      : currentSlideRef?.current?.child?.slideid?._id;

  const popupCloseButtonType = (editor) => {  
    // Component: popup-close-button
    editor.Components.addType("popup-close-button", {
      model: {
        defaults: {
          tagName: "button",
          type: "link",
          components: [
            {
              tagName: "p",
              content: "Close",
              style: {
                margin: '0',
              }
            },
          ],
          attributes: {
            class: "popup-close close",
            'data-close-popup': 'true',
            'data-gjs-highlightable': 'true',
          },
          style: {
            "min-width": "50px",
            "min-height": "50px",
            position: "absolute",
            top: "0px",
            right: "0px",
            border: "none",
            cursor: "pointer",
          },
          traits: [],
        },
      },

    });
  }
  const customPopupBlocktype = (editor) => {
    editor.Components.addType("custom-popup", {
      model: {
        defaults: {
          tagName: "div",
          name: "Custom Popup",
          popupId: "popup-1",
          traits: [
            {
              type: "text",
              label: "Popup ID",
              name: "popupId",
              changeProp: 1,
            },
          ],
          attributes: {
            id: "popup-1",
            class: "gjs-popup",

          },
          droppable: false,
          components: [
            {
              tagName: "div",
              attributes: { class: "popup-overlay" },
              components: [
                {
                  tagName: "div",
                  attributes: { class: "popup-content" },
                  components: [
                    {
                      type: "text",
                      content: "This is a popup!",
                    },
                    {
                      type: "popup-close-button",
                    },
                  ],
                },
              ],
            },
          ],
          styles: `
          .gjs-popup {
            position: fixed;
            top: 0; left: 0; right: 0; bottom: 0;
            background: rgba(0, 0, 0, 0.5);
            display: none;
            z-index: 9999;
          }
          .popup-overlay {
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100%;
          }
          .popup-content {
            background: white;
            padding: 20px;
            border-radius: 8px;
            min-width: 300px;
            box-shadow: 0 0 10px rgba(0,0,0,0.3);
          }
          .popup-close {
            padding: 8px 16px;
            background-color: #dc3545;
            color: #fff;
            border: none;
            border-top-right-radius: 8px;
            border-bottom-left-radius: 8px;
            cursor: pointer;
          }
          .popup-close:hover {
            background-color: #c82333;
          }
        `,
        },
        init() {
          this.on("change:popupId", () => {
            const id = this.get("popupId");
            this.addAttributes({ id });
            // registerPopupId(id);
          });
        },
      },
    });
  }

  const editor = grapesjs.init({
    panels: {
      defaults: [
        {
          id: "editor-actions-btns",
          el: ".panel__editor-btns",

          buttons: [
            //
            // {
            //   id: "cmd-clear",
            //   className: "edDeleteIcon",
            //   command: "cmd-clear",
            // },
            // {
            //   id: "undo",
            //   className: "edUndoIcon",
            //   command: "undo",
            // },
            // {
            //   id: "redo",
            //   className: "edRedoIcon",
            //   command: "redo",
            // },
            // {
            //   id: "export",
            //   // className: "edExportIcon",
            //   command: "export",
            // },
            // {
            //   id: "saveDb",
            //   className: "edSaveIcon",
            //   command: "saveDb",
            // },
            // {
            //   id: "preview",
            //   className: "edPreviewIcon",
            //   command: "preview",
            // },
            {
              id: "visibility",
              active: true, // active by
              className: "edGridIcon",
              // label: "<u>B</u>",

              command: "sw-visibility",
            },
          ],
        },
      ],
    },
    container: "#gjsEditor",
    blockManager: defaultBlocks,
    styleManager: styleManager,
    allowScripts: true,
    keepUnusedStyles: true,
    forceClass: true,
    dragMode: "translate",
    multipleSelection: true,
    // styleManager: { appendTo: "#stylesMangerBlock" },
    // pageManager: {
    //   appendTo: "#PageManager",
    // },
    protectedCss: "",
    // style: `
    // body{font-family: 'Calibri', sans-serif !important; overflow:hidden;}
    // `,
    //projectData: projectData,
    //storageManager: true,

    storageManager: {
      type: "remote",
     // stepsBeforeSave: 5,
       stepsBeforeSave: 1,
      contentTypeJson: true,
      storeComponents: true,
      storeStyles: true,
      storeHtml: true,
      storeCss: true,
      id: "mycustom-",
      options: {
        remote: {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
            "Cache-Control": "no-cache",
            Pragma: "no-cache",
            Expires: "0",
          },
          fetchOptions: (opts) =>
            opts.method === "POST" ? { method: "PATCH" } : {},
          urlLoad: `${moduleApiEndPoint}slides/${IDRef}`,
          urlStore: `${moduleApiEndPointV2}slides/${IDRef}`,
          onStore: (data) => {
            // calculate slide number and mlrstatus
            let master = currentSlideRef?.current?.master;
            let children;
            // const mlrStatus = appData?.deckId?.veevaMetadata?.filter((asset) => asset.assetType === 1)[0].docStatus;        
            if (currentSlideRef?.current?.child === "{}") {
              master = currentSlideRef?.current?.master;
            } else {
              children = currentSlideRef?.current?.master?.children?.filter(l => l?.slideid === currentSlideRef?.current?.child?.slideid)[0];
            }
            let ID =
              JSON.stringify(currentSlideRef?.current?.child) === "{}"
                ? currentSlideRef?.current?.master?.slideid?._id
                : currentSlideRef?.current?.child?.slideid?._id;
            // if (appData.deckId.type === 1)
            //updateModularContenforMM(editor, ID, appData);
            
            let pophtml= editor?getPopUp(editor):'';
            if (!appData.deckId.default_aspect_ratio) {
              let cssString = `@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
${editor?.getCss() +
"body{ width:1024px; height:768px;}" ||""}
[data-slide-id]{cursor:pointer}.tab{cursor:pointer}`;
              let content = {
                editorData: JSON.stringify(data) || "",
                html: editor?.getHtml() || "",
                css: cssString,
                // components: editor.getComponents() || "",
                // styles: editor.getStyle() || "",
                scripts: script,
                  // editor?.getWrapper()?.find("[ccid]").length > 0
                  //   ? script
                  //   : mandatScript,
                thirdPartyPlugins: thirdPartyPlugins,
                extraContent:pophtml,

                //modalBgColor: editor.getWrapper().getStyle()["background-color"],
              };
              return {
                content: content,
                // mlrStatus: mlrStatus,
                // slideNumber: children ? Number(`${master}.${children}`) : master
                thumbnail: children ? children?.slideid?.thumbnail : master?.slideid?.thumbnail
              };
              // setSaveLoading(true);
            } else {
              let content = savingResponsiveData({ storageObjRef, appData, selectedItem, cssRef, editor, data, setStorageObj });
              //if (!storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData)
              content = UpdateHTMLForAllRatios({ editor, appData, content, storageObjRef, setStorageObj, selectedItem, listOfIDRef })
              const defRatio = appData.deckId.default_aspect_ratio;
              if (defRatio && content[defRatio]?.editorData) {
                content.editorData = content[defRatio].editorData;
              }
              return {
                content: content,
                thumbnail: children ? children?.slideid?.thumbnail : master?.slideid?.thumbnail
              };
            }
          },
          onLoad: (result) => {
            setVideoSelected(false);
            const slideDoc = result?.data != null ? result.data : result;
            const content = slideDoc?.content != null ? slideDoc.content : slideDoc;
            if (relatedClaimsDataRef) {
              relatedClaimsDataRef.current = Array.isArray(slideDoc?.relatedClaimsData)
                ? slideDoc.relatedClaimsData
                : [];
            }
            let x =
              JSON.stringify(currentSlideRef?.current?.child) !== "{}"
                ? currentSlideRef.current.child
                : currentSlideRef.current.master;

            const assignSlideNameNKeyMessageToId = (ids, obj) => {
              ids.slideid.key_message =
                ids?.slideid?.key_message || "Enter Key Message";
            };
            // setCurrentSlide({ master: x, child: {} });
            //  currentSlideRef?.current.master = x;
            if (x && JSON.stringify(x) !== "{}") {
              assignSlideNameNKeyMessageToId(x, result);

              // let tempSlideID = [
              //   ...slideID,
              //   (slideID[x.index - 1] = currentSlideRef?.current?.master),
              // ];
              // let array = tempSlideID.filter(
              //   (value, index, self) =>
              //     index ===
              //     self.findIndex((t) => t?.slideid?._id === value?.slideid?._id)
              // );
              //setSlideID(array);
            }
            if (content != null && typeof content === "object") {
              setStorageObj(content);
            }
            setTimeout(() => {
              setLoading(false)
            }, 1000);

            const defaultRatio = appData?.deckId?.default_aspect_ratio;
            let editorDataStr =
              content && typeof content.editorData === "string"
                ? content.editorData
                : "{}";
            if (defaultRatio && selectedItem && content?.[selectedItem]?.editorData) {
              editorDataStr = content[selectedItem].editorData;
            } else if (defaultRatio && content?.[defaultRatio]?.editorData) {
              editorDataStr = content[defaultRatio].editorData;
            }
            return JSON.parse(editorDataStr || "{}");
          },
        },
      },
    },
    layerManager: {
      // If the `root` is not specified or the component element is not found,
      // the main wrapper component will be used.
      appendTo: '#layerHtml',
      custom: true,
      sortable: true,
      hidable: true,
    },
    assetManager: {
      // ...
      types: ['image'],
      custom: {
        open(props) {
          setState(true);
        },
        close(props) { },
      },
    },
    style: `
    body{background-color:#fff;margin:0; width:1024px; height:768px;  }
     *{box-sizing: border-box;} input, textarea, select {border-width: 1px; border-color: -internal-light-dark(rgb(118, 118, 118), rgb(133, 133, 133)); border-style: inset;}
  .modal{display:none;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.6)}
      .modal-content{margin:0;height:100%;width:100%;padding:0;}.close{position:absolute;right:0;}iframe.modal-iframe{height:100%;width:100%;border:0;margin-top:0px;}[data-slide-id]{cursor:pointer}`,
    canvas: {
      // style: localScripts,
      scripts: localLink,
      styles: cssLink
    },

    traitManager: {
      appendTo: "#traitBlock",
    },
    selectorManager: {
      appendTo: "#stylesMangerBlock",
      custom: true,
    },

    plugins: [
      cutomTraitsLinkPlugin,
      //customType, //Imported for smart template feature classic/Modular toggele
      //commonHtmlType, //common html toggle and feature can be enable
      "gjs-blocks-basic",
      grapesJsexportPlugin,
      gjsTabs,
      //gjsTable,
      (editor) =>
        gjsTable(editor, {
          tableBlock: {
            label: "Table",
            category: "",
            activate: false,
          },

          tableProps: {
            rows: 3,
            columns: 3,
            header: false,
            footer: false,
            editable: 1,
            unstylable: [
              // "display",
              "transform",
              "transition",
              "perspective",
              "modular_content",
            ],
          },
        }),
      // grapesjsrteextensions,
      // (editor) =>
      //   gjsForm(editor, {
      //     blocks: ["select", "form"],
      //     container: "#gjsforms",
      //   }),
      (editor) =>
        grapesJsFormsPlugin(editor, {
          formBlock: {
            label: "Forms",
            category: "form",
            activate: false,
          },
        }),
        popupCloseButtonType,
        customPopupBlocktype,
        customTigger,
    ],

    pluginsOpts: {
      "gjs-blocks-basic": {
        // Which blocks to add'
        // stylePrefix: "", // no gjs- prefix

        blocks: blocks,
        flexGrid: 1,
      },
      // "grapesjs-rte-extensions": {
      //   // default options
      //   base: {
      //     bold: true,
      //     italic: true,
      //     underline: true,
      //     strikethrough: true,
      //     link: true,
      //   },
      //   subscriptSuperscript: true,
      //   //fonts: {
      //   //  fontName: ['font1',...,'fontn'],
      //   //  fontSize: true,
      //   //  //An array of strings representing colors
      //   //  fontColor: ['#fff',...],
      //   //  //An array of strings representing colors
      //   //  hilite: ['#fff',...],
      //   //}
      //   fonts: {
      //     fontColor: true,
      //     hilite: true,
      //   },
      //   format: {
      //     heading1: true,
      //     heading2: true,
      //     heading3: true,
      //     //heading4: false,
      //     //heading5: false,
      //     //heading6: false,
      //     paragraph: true,
      //     //quote: false,
      //     clearFormatting: true,
      //   },
      //   //|true
      //   indentOutdent: true, //|true
      //   list: false, //|true
      //   align: true, //|true
      //   //actions: {
      //   //  copy: true,
      //   //  cut: true,
      //   //  paste: true,
      //   //  delete: true,
      //   //},
      //   actions: false, //|true
      //   undoredo: false, //|true
      //   extra: false, //|true
      //   darkColorPicker: true, //|false
      //   maxWidth: "600px",
      // },

      //gjsTabs: {},
      //gjsTable: {},
      //gjsForm: { blocks: formblocks },
    },

    showDevices: false,
    showPreview: false,
    //showToolbar: false,
    devicePreviewMode: false,
    undoManager: { maximumStackLength: 4000, enabled: true },
  });
  window.editor = editor;
  //editor.getModel().set("dmode", "absolute");
  // editor.getModel().set("dmode", "absolute");

  /** Programmatic layout tweaks after add/select; must not consume extra undo steps vs the user's action. */
  const withoutUndo = (fn) => {
    const um = editor.UndoManager;
    if (um && typeof um.skip === "function") {
      um.skip(fn);
    } else {
      fn();
    }
  };


  // Automatic width assignment and resizable from all sides: Column blocks and rows get 50% width by default
  const setColumnBlockWidth = (component) => {
    if (!component) return;
    
    // Check if it's a column/cell block from gjs-blocks-basic
    const componentType = component.get('type');
    const componentClasses = component.get('classes');
    const parent = component.parent();
    
    // Check for row components (.gjs-row)
    const isRow = 
      componentType === 'row' || 
      (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
        const className = cls.get('name') || '';
        return className === 'gjs-row';
      }));
    
    // Column blocks are typically 'cell' type or have specific classes
    const isColumnBlock = 
      componentType === 'cell' || 
      (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
        const className = cls.get('name') || '';
        return className.includes('gjs-f-b') || 
               className.includes('column') || 
               className === 'gjs-cell';
      })) ||
      (parent && parent.get('type') === 'row');
      
    if (component.attributes.name === "Row" || component.attributes.type === "Div") { // isColumnBlock || isRow
      // Set default width to 50% if not already set
      const currentWidth = component.getStyle('width');
      if (!currentWidth || currentWidth === 'auto' || currentWidth === '' || currentWidth === '0px') {
        setTimeout(() => {
          withoutUndo(() => {
            if (!component.getStyle('width') || component.getStyle('width') === 'auto') {
              component.addStyle({ width: '70%' });
            }
          });
        }, 10);
      }
      
      // Enable resizable from all sides
      setTimeout(() => {
        withoutUndo(() => {
          component.set('resizable', {
            tl: 1, // top-left
            tc: 1, // top-center
            tr: 1, // top-right
            cl: 1, // center-left
            cr: 1, // center-right
            bl: 1, // bottom-left
            bc: 1, // bottom-center
            br: 1, // bottom-right
            ratioDefault: false,
            minDim: 50, // minimum dimension
          });
        });
      }, 10);
    }
  };

  // Set width when component is added
  editor.on('component:add', (component) => {
    setColumnBlockWidth(component);
  });

  editor.on('storage:start:store', () => {
    const wrapper = editor.getWrapper();

    wrapper.find('br').forEach(comp => {
      const parent = comp.parent();

      if (!parent) return;

      if (parent.attributes.name === 'Cell') {
        const siblings = parent.components();
        const hasImage = siblings.some(c => c.get('type') === 'image');

        if (siblings.length === 2 && hasImage) {
          comp.remove();
        }
      }
    });
  });

  // Also set width when component is updated
  editor.on('component:update', (component) => {
    setColumnBlockWidth(component);
  });

  // Set width when component is selected (in case it was missed)
  editor.on('component:selected', (component) => {
    withoutUndo(() => {
      setColumnBlockWidth(component);
      
      // Ensure resizable is enabled from all sides when selected
      const componentType = component.get('type');
      const componentClasses = component.get('classes');
      const parent = component.parent();
      
      const isRow = 
        componentType === 'row' || 
        (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
          const className = cls.get('name') || '';
          return className === 'gjs-row';
        }));
      
      const isColumnBlock = 
        componentType === 'cell' || 
        (componentClasses && componentClasses.length > 0 && componentClasses.some(cls => {
          const className = cls.get('name') || '';
          return className.includes('gjs-f-b') || 
                 className.includes('column') || 
                 className === 'gjs-cell';
        })) ||
        (parent && parent.get('type') === 'row');
      
      if (isColumnBlock || isRow) {
        component.set('resizable', {
          tl: 1, tc: 1, tr: 1,
          cl: 1, cr: 1,
          bl: 1, bc: 1, br: 1,
          ratioDefault: false,
          minDim: 50,
        });
      }
    });
  });
  
  let clickedSaveBtn = false;
  const fontlist = editor.StyleManager.getProperty("typography", "font-family");
  const hideFormsBlockss = document?.querySelector(".gjs-block-categories")
    ?.childNodes[1];
  hideFormsBlockss?.classList.add("d-none", "forms-field-block");

  // Typography color picker behavior:
  // cancel/close (cross) should revert to previous color on RHS + selected element.
  let colorPickerSnapshot = null;
  let pendingColorRestore = null;
  const isColorPickerCancelTarget = (target) =>
    !!(
      target.closest(".sp-cancel") ||
      target.closest(".sp-close") ||
      target.closest(".sp-button-close")
    );

  const snapshotColorBeforePicker = () => {
    const selected = editor.getSelected?.();
    if (!selected) return;
    colorPickerSnapshot = {
      ccid: selected.ccid,
      model: selected,
      prevColor: selected.getStyle?.()?.color || "",
      chosen: false,
    };
    pendingColorRestore = null;
  };

  const markColorChosen = () => {
    if (!colorPickerSnapshot) return;
    colorPickerSnapshot.chosen = true;
    pendingColorRestore = null;
  };

  const restorePreviousColor = (model, prevColor) => {
    if (!model) return;
    if (!prevColor) {
      model.removeStyle?.("color");
    } else {
      model.addStyle?.({ color: prevColor });
    }
  };

  const revertColorIfCanceled = () => {
    if (!colorPickerSnapshot || colorPickerSnapshot.chosen) return;
    const targetModel = colorPickerSnapshot.model || editor.getSelected?.();
    if (!targetModel) {
      colorPickerSnapshot = null;
      return;
    }
    const prevColor = colorPickerSnapshot.prevColor || "";
    pendingColorRestore = {
      ccid: colorPickerSnapshot.ccid || targetModel.ccid,
      model: targetModel,
      prevColor,
      until: Date.now() + 2000,
    };
    const apply = () => restorePreviousColor(targetModel, prevColor);
    apply();
    // Protect against delayed blur/focus writes from color picker internals.
    setTimeout(apply, 0);
    setTimeout(apply, 60);
    setTimeout(apply, 180);
    setTimeout(apply, 400);
    setTimeout(apply, 900);
    colorPickerSnapshot = null;
  };

  document.addEventListener("mousedown", (ev) => {
    const target = ev.target;
    if (!(target instanceof Element)) return;
    const inColorProp =
      target.closest('[data-property="color"]') ||
      target.closest(".gjs-sm-property__color");
    if (
      inColorProp &&
      (target.closest(".gjs-field-color-picker") ||
        target.closest(".gjs-field.gjs-field-color"))
    ) {
      snapshotColorBeforePicker();
    }
  });

  document.addEventListener("click", (ev) => {
    const target = ev.target;
    if (!(target instanceof Element)) return;
    if (target.closest(".sp-choose")) {
      markColorChosen();
      return;
    }
    if (isColorPickerCancelTarget(target)) {
      revertColorIfCanceled();
    }
  });

  // capture phase handles cross icon before other handlers mutate selection/state
  document.addEventListener(
    "mousedown",
    (ev) => {
      const target = ev.target;
      if (!(target instanceof Element)) return;
      if (isColorPickerCancelTarget(target)) {
        setTimeout(revertColorIfCanceled, 0);
      }
    },
    true,
  );

  const enforcePendingColorRestore = () => {
    if (!pendingColorRestore) return;
    if (Date.now() > pendingColorRestore.until) {
      pendingColorRestore = null;
      return;
    }
    const model = pendingColorRestore.model;
    if (!model) {
      pendingColorRestore = null;
      return;
    }
    restorePreviousColor(model, pendingColorRestore.prevColor);
  };

  document.addEventListener(
    "mousedown",
    (ev) => {
      const target = ev.target;
      if (!(target instanceof Element)) return;
      const insidePicker =
        target.closest(".sp-container") ||
        target.closest(".gjs-field-color-picker");
      if (!insidePicker) {
        setTimeout(enforcePendingColorRestore, 0);
        setTimeout(enforcePendingColorRestore, 60);
      }
    },
    true,
  );

  editor.on("style:property:update", (sector) => {
    const prop =
      sector?.property?.attributes?.property || sector?.property?.id || "";
    if (prop !== "color" || !pendingColorRestore) return;
    const model = pendingColorRestore.model || editor.getSelected?.();
    if (!model) {
      pendingColorRestore = null;
      return;
    }
    if (Date.now() > pendingColorRestore.until) {
      pendingColorRestore = null;
      return;
    }
    restorePreviousColor(model, pendingColorRestore.prevColor);
    setTimeout(
      () => restorePreviousColor(model, pendingColorRestore.prevColor),
      0,
    );
  });
  editor.on("component:selected", () => {
    enforcePendingColorRestore();
  });
  editor.on("component:deselected", () => {
    setTimeout(enforcePendingColorRestore, 0);
  });


  // delete br tag after image is deleted
  editor.on('component:remove', (component) => {
    if (component.get('type') === 'image') {
      const parent = component?.parent();
      if (!parent) return;

      // Defer the cleanup until after the image is removed
      setTimeout(() => {
        parent?.components().forEach(child => {
          const isBrTag = child?.get('tagName') === 'br';
          if (isBrTag) {
            child.remove();
          }
        });
      }, 0);
    }
  });

  editor.on('component:drag:end', (comp) => {
    if (RESPONSIVE_DIM_KEYS.includes(selectedItem)) {

      const value = comp.target.getStyle().transform;
      const storageId = getCssStorageId(comp.target);
      if (!storageId) return;
      const selectedElement = cssRef.current[selectedItem].find(
        (obj) => String(obj.id) === String(storageId),
      );
      let allElement = [...cssRef.current[selectedItem]];
      if (!selectedElement) {
        allElement.push({ id: storageId, transform: value });
      } else {
        allElement = allElement.map((o) =>
          String(o.id) === String(selectedElement.id) ? { ...o, transform: value } : o,
        );
      }
      let allDimensions = { ...cssRef.current, [selectedItem]: allElement };
      setCSSState(allDimensions);
      cssRef.current = allDimensions;
      persistResponsiveCssObjFromCssRef(selectedItem);
    }
  });

  let translateX = false, translateY =false;
  editor.on('style:property:update', (sector, test) => {
    if (!RESPONSIVE_DIM_KEYS.includes(selectedItem)) return;
    if (!sector?.property?.attributes) return;
    if (sector.property.attributes.property === "name" ) {
        translateY = sector.property.attributes.value === "translateY";
        translateX = sector.property.attributes.value === "translateX";
        return;
    }

    const getTransformValue = (comp) => {
        if (!comp) return "";

        let transform = comp.getStyle().transform || '';

        if (translateX) {
          transform = transform.includes('translateX')
            ? transform.replace(/translateX\(\s*-?\d*\.?\d+(px|%|em|rem|vh|vw)\s*\)/, `translateX(${sector.value})`)
            : `${transform} translateX(${sector.value})`;
        }
        if (translateY) {
          transform = transform.includes('translateY')
            ? transform.replace(/translateY\(\s*-?\d*\.?\d+(px|%|em|rem|vh|vw)\s*\)/, `translateY(${sector.value})`)
            : `${transform} translateY(${sector.value})`;
        }

        return transform;
    };

    const isEmptyStyleValue = (v) =>
      v == null || (typeof v === "string" && v.trim() === "");

    const targets = getSelectedComponentsForCssSync(editor);
    if (!targets.length) return;

    const propKey = resolveStyleManagerPropKey(sector.property);
    if (!propKey) return;

    if (isEmptyStyleValue(sector.value)) {
      let allElement = Array.isArray(cssRef.current[selectedItem])
        ? [...cssRef.current[selectedItem]]
        : [];

      targets.forEach((model) => {
        const storageId = getCssStorageId(model);
        if (!storageId) return;

        allElement = allElement.flatMap((o) => {
          if (String(o.id) !== String(storageId)) return [o];
          const row = { ...o };
          if (isResponsiveStyleStoragePropKey(propKey)) {
            if (propKey === "value") delete row.value;
            stripResponsiveStyleGroupFromCssRow(row, propKey);
            if (propKey === "value") {
              const t = (model.getStyle?.().transform || "").trim();
              if (t && t !== "none") row.transform = t;
              else delete row.transform;
            }
          } else {
            delete row[propKey];
          }
          const restKeys = Object.keys(row).filter((k) => k !== "id");
          if (restKeys.length === 0) return [];
          return [row];
        });
      });

      const allDimensions = { ...cssRef.current, [selectedItem]: allElement };
      setCSSState(allDimensions);
      cssRef.current = allDimensions;
      persistResponsiveCssObjFromCssRef(selectedItem);
      return;
    }

    let allElement = Array.isArray(cssRef.current[selectedItem])
      ? [...cssRef.current[selectedItem]]
      : [];

    targets.forEach((model) => {
      const storageId = getCssStorageId(model);
      if (!storageId) return;

      const selectedElement = allElement.find(
        (obj) => String(obj.id) === String(storageId),
      );

      if (!selectedElement) {
        let obj = {
          id: storageId,
          [sector.property.attributes.property]: sector.value,
        };
        if (sector.property.attributes.property == "value") {
          let transform = getTransformValue(model);
          delete obj?.value;
          obj.transform = (transform || "").trim();
        }
        allElement.push(obj);
      } else {
        let obj = { [sector.property.attributes.property]: sector.value };
        if (sector.property.attributes.property == "value") {
          let transform = getTransformValue(model);
          delete obj?.value;
          obj.transform = (transform || "").trim();
        }
        allElement = allElement.map((o) =>
          String(o.id) === String(selectedElement.id) ? { ...o, ...obj } : o,
        );
      }
    });

    let allDimensions = { ...cssRef.current, [selectedItem]: allElement };
    setCSSState(allDimensions);
    cssRef.current = allDimensions;
    persistResponsiveCssObjFromCssRef(selectedItem);
  }); 
  //commented it on Siva's ask for dimen fix
  /* editor.on('style:property:update', (sector, test) => { 
    if (selectedItem==="dim_1024*768" &&  sector.value){
      const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
      let arrObj=[];
      if (!resultEdObject){
        
        let obj={id:editor?.getSelected()?.ccid,
                // property:sector.property.id,
                [sector.property.id]:sector.value}
        arrObj.push(obj)
      }else{
       
        let obj= {[sector.property.id]:sector.value}
        //resultEdObject
        arrObj.push({...resultEdObject, ...obj})
      }
     let obj2= {...cssRef.current,"dim_1024*768":arrObj}
        setCSSState(obj2)
        cssRef.current=obj2

    }else if (selectedItem==="dim_2752*2064" &&  sector.value){
        const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
        let arrObj=[];
        if (!resultEdObject){
        
          let obj={id:editor?.getSelected()?.ccid,
                  // property:sector.property.id,
                  [sector.property.id]:sector.value}
          arrObj.push(obj)
        }else{
          
          let obj= {[sector.property.id]:sector.value}
          //resultEdObject
          arrObj.push({...resultEdObject, ...obj})
        }
        let obj2= {...cssRef.current,"dim_2752*2064":arrObj }
        setCSSState(obj2)
        cssRef.current=obj2
     
    }else if(selectedItem==="dim_2388*1668" && sector.value){
    
        const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
          let arrObj=[];
          if (!resultEdObject){
        
            let obj={id:editor?.getSelected()?.ccid,
                    // property:sector.property.id,
                    [sector.property.id]:sector.value}
            arrObj.push(obj)
          }else{
     
             let obj= {[sector.property.id]:sector.value}
             //resultEdObject
              arrObj.push({...resultEdObject, ...obj})
           }
           let obj2= {...cssRef.current,"dim_2388*1668":arrObj }
           setCSSState(obj2)
           cssRef.current=obj2
    }else if(selectedItem==="dim_2048*1536" && sector.value){
    
      const resultEdObject = [...cssRef.current[selectedItem]].find(obj => obj.id === editor.getSelected()?.ccid);
        let arrObj=[];
        if (!resultEdObject){
      
          let obj={id:editor?.getSelected()?.ccid,
                  // property:sector.property.id,
                  [sector.property.id]:sector.value}
          arrObj.push(obj)
        }else{
   
           let obj= {[sector.property.id]:sector.value}
           //resultEdObject
            arrObj.push({...resultEdObject, ...obj})
         }
         let obj2= {...cssRef.current,"dim_2048*1536":arrObj }
         setCSSState(obj2)
         cssRef.current=obj2
  }
    
  }); 
 */
  editor.Commands.add("set-device-desktop", {
    run: (editor) => editor.setDevice("Desktop"),
  });
  editor.Commands.add("set-device-mobile", {
    run: (editor) => editor.setDevice("Mobile"),
  });

  // editor.Commands.add('core:paste', editor => {
  //  // const selected = editor.getSelected();
  //   debugger;
  // });
  // editor.on("rteToolbarPosUpdate", (pos) => {
  //   if (pos.top <= pos.canvasTop) {
  //     pos.top = pos.elementTop + pos.elementHeight;
  //   }
  // });
  // Save Button
  editor.Commands.add("saveDb", {
    run: async (editor, sender) => {
      setSaveLoading(true);
      clickedSaveBtn = true;
      // refSaveLoading.current = true;
      // sender && sender.set("active");
    //  editor.runCommand("sw-visibility");  //commented this line for-CIA-2405
      try {
        // Refresh Keycloak token before save
        if (keycloak) {
          await keycloak.updateToken(10);
        }
        await editor.store(); // store is now safe
      } catch (err) {
        showErrorToast("Save failed. Please try again.");
      } finally {
        setSaveLoading(false);
      }
      return;
    },
  });

  // editor.Commands.add('image-single-click', {
  //     run(editor, sender, options) {
  //       alert('Image placeholder clicked!');
  //     }
  //   });
//     editor.DomComponents.addType('image', {
//       model: {
//         defaults: {
//           tagName: 'img',
//           // attributes: { src: '' },
//           attributes: { 
//             src: ''  // default placeholder image
//           },
//           style: {
//             width: '450px',  // fixed starting width
//             height: '450px'  // fixed starting height
//           },
//           // Start unlocked
//           resizable: {
//             ratioDefault: false,
//             tl: 0, tr: 0, bl: 0, br: 1 // only bottom-right handle
//           },
    
//           traits: [
//             {
//               type: 'text',
//               name: 'src',
//               label: 'Image URL'
//             },
//             {
//               type: 'checkbox',
//               name: 'keepAspect',
//               label: 'Lock Aspect Ratio',
//               changeProp: 1
//             }
//           ],
    
//           toolbar: [
//             {
//               attributes: { class: 'fa fa-lock' },
//               command: 'toggle-aspect',
//               label: 'Aspect Ratio'
//             },
//             'resizer', // keep default resizer handles
//             'tl', 'tr', 'bl', 'br'
//           ]
//         },
    
//         init() {
//           // React to trait changes
//           this.on('change:keepAspect', () => {
//             const keep = this.get('keepAspect');
//             const resizable = this.get('resizable') || {};
//             this.set('resizable', { ...resizable, ratioDefault: keep });
//           });
//         }
//       }
//     });

//     editor.Components.addType('image-single-click', {
//   // It's a good practice to extend an existing component.
//   extend: 'image',

//   // Define the custom View object.
//   view: {
//     // Override the `events` property to add a `click` listener.
//     // The key is the event name (`click`), and the value is the method to call (`showAssetManager`).
//     events: {
//       'dblclick': 'preventDblclick', // Optional: disable the default double-click behavior
//       'click': 'showAssetManager',
//     },

//     // Define the custom method to execute on a single click.
//     showAssetManager(event) {
//       // Prevent the event from bubbling up to avoid conflicts.
//       event.stopPropagation();
      
//       // Get the Asset Manager and open it.
//       const am = this.em.get('AssetManager');
//       am.open();

//       // Ensure that on selecting an asset, the image component's `src` is updated.
//       am.onSelect(asset => {
//         const selectedComponent = this.model;
//         if (selectedComponent.is('image-single-click')) {
//           selectedComponent.addAttributes({ src: asset.getSrc() });
//         }
//         // Close the asset manager after selection.
//         am.close();
//       });
//     },

//     // Define a method to prevent the default double-click.
//     preventDblclick(event) {
//       event.stopPropagation();
//     }
//   },
// });

  editor.Commands.add("preview", {
    run: async (editor) => {
      setExportLoading(true);
      await editor.store();
      //editor.runCommand("sw-visibility");   //commented this line for-CIA-2405
      let cardDataID = appData?.deckId?._id;
      /* let removeSlide = window.localStorage.getItem("removedSlieId");
      let wrapper = editor.getWrapper().find(`[data-slide-id="${removeSlide}"]`);
      if (wrapper?.length > 0) {
        var comp = editor.getComponents();
        comp.remove(wrapper);
      } */
      ExportDeckToMail(
        cardDataID,
        (response, err, errorCode) => {
          if (err) {
            setExportLoading(false);
            showErrorToast(`Preview Failed. ${err}`);
          } else {
            setExportLoading(false);
            setShowPreView(true);
          }
        },
        "preview=true"
      );
    },
  });
  //Clear Button
  editor.Commands.add("cmd-clear", {
    run: (editor) => {
      editor.DomComponents.clear();
      editor.CssComposer.clear();
    },
  });

  let storageObjSyncDebounceTimer = null;
  const scheduleStorageObjSyncAfterRemoval = () => {
    if (typeof setStorageObj !== "function") return;
    clearTimeout(storageObjSyncDebounceTimer);
    storageObjSyncDebounceTimer = setTimeout(() => {
      storageObjSyncDebounceTimer = null;
      try {
        setStorageObj({ ...storageObjRef.current });
      } catch (_) {}
    }, 150);
  };

  // Keep storageObj[dim].cssObj in sync with cssRef when styles change.
  // This prevents Editor.js from restoring stale cssState on dimension switch.
  const persistResponsiveCssObjFromCssRef = (dim) => {
    if (!appData?.deckId?.default_aspect_ratio || !storageObjRef?.current) return;
    if (!RESPONSIVE_DIM_KEYS.includes(dim)) return;
    const rows = Array.isArray(cssRef.current[dim])
      ? [...cssRef.current[dim]]
      : [];
    const ref = storageObjRef.current;
    const prevSlot = ref[dim];
    const cssStr = buildDimensionCssString(dim, rows);
    ref[dim] =
      prevSlot && typeof prevSlot === "object"
        ? { ...prevSlot, cssObj: rows, css: cssStr }
        : { editorData: ref.editorData || "", cssObj: rows, css: cssStr };
    storageObjRef.current = { ...ref };
    if (typeof setStorageObj === "function") {
      try {
        setStorageObj({ ...storageObjRef.current });
      } catch (_) {}
    }
  };

  /** Multi-dim: clear canvas + reset cssRef / all dim editorData+cssObj+css (single React update). */
  editor.Commands.add("clear-slide-all-dimensions", {
    run(ed) {
      ed.DomComponents.getComponents().at(0).empty();
      ed.select(ed.DomComponents.getComponents().at(0));
      if (!appData?.deckId?.default_aspect_ratio || !ed.getProjectData) return;
      const pj = JSON.stringify(ed.getProjectData());
      const ref = storageObjRef.current;
      if (!ref) return;
      RESPONSIVE_DIM_KEYS.forEach((dim) => {
        const slot = ref[dim];
        ref[dim] = {
          ...(slot && typeof slot === "object" ? slot : {}),
          editorData: pj,
          cssObj: [],
          css: buildDimensionCssString(dim, []),
        };
      });
      ref.editorData = pj;
      const cleared = {};
      RESPONSIVE_DIM_KEYS.forEach((k) => {
        cleared[k] = [];
      });
      cssRef.current = { ...cssRef.current, ...cleared };
      setCSSState((prev) => ({ ...prev, ...cleared }));
      if (typeof setStorageObj === "function") {
        setStorageObj({ ...ref });
      }
    },
  });

  const scheduleSyncModuleUsed = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (typeof editor.refresh === "function") {
          editor.refresh();
        }
        syncSelectedModuleUsedFromCanvas(editor, appData);
      });
    });
  };
  //Undo
  editor.Commands.add("undo", {
    run: (ed) => {
      ed.UndoManager.undo();
      syncAllDimensionsFromRestore(ed);
      scheduleSyncModuleUsed();
    },
  });
  // Redo
  editor.Commands.add("redo", {
    run: (ed) => {
      ed.UndoManager.redo();
      syncAllDimensionsFromRestore(ed);
      scheduleSyncModuleUsed();
    },
  });

  editor.syncAllDimensionsFromRestore = () => syncAllDimensionsFromRestore(editor);

  editor.Commands.add("export", {
    run: async (editor) => {
      setOpenExportModal(true);
      await editor.store();
     // editor.runCommand("sw-visibility");   //commented this line for-CIA-2405
      // let cardData = JSON.parse(window.localStorage.getItem("edetailData"));
      // setExportLoading(true);

      // ExportDeckToMail(cardData.edetailId, (response, err, errorCode) => {
      //   if (err) {
      //     toast.error(
      //       <div className="">{`Export Failed.. Please Try Again`}</div>,
      //       {
      //         autoClose: 3000,
      //         closeOnClick: true,
      //         pauseOnHover: true,
      //         draggable: false,
      //         progress: undefined,
      //       }
      //     );
      //     setExportLoading(false);
      //   } else {
      //     toast.success(<div className="">{`Link will be mailed`}</div>, {
      //       autoClose: 5000,
      //       progress: undefined,
      //       closeOnClick: true,
      //       pauseOnHover: true,
      //       draggable: false,
      //     });
      //     setExportLoading(false);
      //   }
      // });
    },
    // run: (editor) => editor.runCommand("gjs-export-zip"),
  });
  // Show guides
  editor.Commands.add("visibility", {
    run: (editor) => editor.runCommand("sw-visibility"),
  });
  let error = 0;
  editor.on("storage:error:store", async (err, data) => {
    // showErrorToast('Save failed. Pl try again');
    // setSaveLoading(false);
    error = 1;
  });

  let updateText = document.getElementsByClassName("gjs-toolbar");
  let changeText = document.getElementsByClassName(
    "gjs-rte-toolbar gjs-one-bg"
  );

  editor.on("rte:enable", () => {
    if (changeText && changeText[0]) {
      updateText[0].style.display = "none";
    }
    const comp = editor.getSelected();

    // For parent-claim and related-claim elements: allow toolbar to show but prevent content editing
    const isParentClaim = comp && comp.getAttributes() && comp.getAttributes()["parent-claim"];
    const isRelatedClaim = comp && comp.getAttributes() && comp.getAttributes()["related-claim"];
    
    if (isParentClaim || isRelatedClaim) {
      // Allow contenteditable for RTE toolbar to work, but prevent text input
      const el = comp.getEl();
      if (el) {
        // Use setTimeout to ensure RTE has initialized
        setTimeout(() => {
          // Keep contenteditable true so toolbar can apply styles
          // But prevent actual text input via keyboard
          const preventTextInput = (e) => {
            // Allow toolbar button clicks and execCommand operations
            // Prevent actual text character input (but allow Ctrl/Cmd combinations for formatting)
            if (e.key && e.key.length === 1 && !e.ctrlKey && !e.metaKey && !e.altKey) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            // Always prevent backspace/delete to prevent any content deletion
            if ((e.key === 'Backspace' || e.key === 'Delete') && !e.ctrlKey && !e.metaKey) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            // Allow Enter key to be handled by toolbar if needed, but prevent it from adding content
            if (e.key === 'Enter' && !e.ctrlKey && !e.metaKey) {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          };
          
          // Remove existing listeners to avoid duplicates
          const existingHandler = el._preventTextInputHandler;
          if (existingHandler) {
            el.removeEventListener('keydown', existingHandler, true);
            el.removeEventListener('keypress', existingHandler, true);
          }
          
          // Store handler reference for cleanup
          el._preventTextInputHandler = preventTextInput;
          
          // Add new listeners
          el.addEventListener('keydown', preventTextInput, true);
          el.addEventListener('keypress', preventTextInput, true);
          
          // Prevent input events that would add or delete text content, but allow formatting
          const preventTextInputEvent = (e) => {
            // Prevent text insertion
            if (e.inputType === 'insertText' || 
                e.inputType === 'insertCompositionText' ||
                e.inputType === 'insertParagraph' ||
                e.inputType === 'insertLineBreak') {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            // Prevent content deletion
            if (e.inputType === 'deleteContent' ||
                e.inputType === 'deleteContentBackward' ||
                e.inputType === 'deleteContentForward' ||
                e.inputType === 'deleteByDrag' ||
                e.inputType === 'deleteByCut') {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            // Allow formatting operations like formatBold, formatItalic, etc.
            // These don't have inputType 'insertText' or 'deleteContent'
          };
          
          // Use beforeinput for better control
          el.addEventListener('beforeinput', (e) => {
            // Prevent text insertion
            if (e.inputType === 'insertText' || 
                e.inputType === 'insertCompositionText' ||
                e.inputType === 'insertParagraph' ||
                e.inputType === 'insertLineBreak') {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
            // Prevent content deletion
            if (e.inputType === 'deleteContent' ||
                e.inputType === 'deleteContentBackward' ||
                e.inputType === 'deleteContentForward' ||
                e.inputType === 'deleteByDrag' ||
                e.inputType === 'deleteByCut') {
              e.preventDefault();
              e.stopPropagation();
              return false;
            }
          }, true);
          
          // Also handle input event as fallback
          el.addEventListener('input', preventTextInputEvent, true);
        }, 0);
      }
    }

    if (comp.get("type") == "link") {
      editor.Canvas.getBody().addEventListener("keydown", (e) => {
        if (e.code === "Space") {
          e.preventDefault();
          e.stopPropagation();
          const selection = e.target.ownerDocument.getSelection();
          selection.deleteFromDocument();
          const emptSpace = "\u00A0";
          selection
            .getRangeAt(0)
            .insertNode(document.createTextNode(emptSpace));
          selection.collapseToEnd();
          return false;
        }
      });
    } else {
      //  editor.Canvas.getBody().removeEventListener("keydown");
    }
  });

  editor.on("rte:disable", () => {
    if (updateText && updateText[0]) {
      updateText[0].style.display = "block";
    }
  });

  // editor.on('rteToolbarPosUpdate', (pos) => {
  //   const blueToolbar = document.querySelector(".gjs-toolbar");
  //   blueToolbar.style.display = "none"
  // });
  editor.on("storage:end:store", () => {
    
    !error &&
      clickedSaveBtn && showSuccessToast('Save successful');
    clickedSaveBtn = false;
    // setSaveLoading(false);
    setDimensionVariable(true);
    
    /* if (localStorage.getItem('SwitchDimen')) {
      editor.load();
      setTimeout(() => {
        localStorage.removeItem('SwitchDimen')
      }, 0);
      
    } */
  });

  let error2;
  editor.on("storage:error:load", () => {
    setSaveLoading(false);
    setLoadSuccess(false);
    error2 = 1;
  });
  editor.on("storage:end:load", () => {
    setSaveLoading(false);

    !error2 && setLoadSuccess(true);
  });
  let lastMousePos = { x: null, y: null };

  let lastHoveredImagePlaceholder = null;

  editor.on("canvas:dragover", (ev) => {
    // Track mouse position for drop positioning
    const cx = (ev && (ev.clientX ?? ev.x ?? (ev.event && ev.event.clientX)));
    const cy = (ev && (ev.clientY ?? ev.y ?? (ev.event && ev.event.clientY)));
    if (typeof cx === 'number' && typeof cy === 'number') {
      lastMousePos.x = cx;
      lastMousePos.y = cy;
    }
    let hoveredImage = null;
    const imageComponents = editor.DomComponents?.getWrapper()?.findType("image");
    if (imageComponents && Array.isArray(imageComponents)) {
      const hits = [];
      imageComponents.forEach((imageComponent) => {
        const element = imageComponent?.view?.el;
        if (!element) {
          return;
        }
        const position = element.getBoundingClientRect();
        const inside =
          typeof cx === "number" &&
          typeof cy === "number" &&
          cx >= position.left &&
          cx <= position.right &&
          cy >= position.top &&
          cy <= position.bottom;
        if (inside) {
          const area = Math.max(0, position.width) * Math.max(0, position.height);
          hits.push({ cmp: imageComponent, area });
        }
      });
      if (hits.length) {
        hits.sort((a, b) => a.area - b.area);
        hoveredImage = hits[0].cmp;
      }
    }
    window.localStorage.setItem("drop", true);
    if (hoveredImage) {
      const selected = editor.getSelected();
      if (selected !== hoveredImage) {
        editor.select(hoveredImage);
      }
      lastHoveredImagePlaceholder = hoveredImage;
    } else {
      lastHoveredImagePlaceholder = null;
      editor.select(null);
    }
  });

  editor.on('block:drag:start', ( _, element ) => {
    element.dataTransfer.setDragImage(element.srcElement, 0, 0);
  });

  const refreshUndoRedoFromManager = () => {
    const um = editor.UndoManager;
    if (!um) return;
    setRedoCurrentStatus(um.hasUndo());
    setUndoCurrentStatus(um.hasRedo());
  };

  editor.on("component:selected", () => {
    refreshUndoRedoFromManager();
  });

  /* Undo stack does not depend on selection, but we only refreshed on select — block:drag:stop / canvas:dragover call select(null), so enable Undo after LHS drop. */
  editor.on("component:deselected", () => {
    requestAnimationFrame(() => refreshUndoRedoFromManager());
  });

  editor.on("component:toggled", () => {
    //Hides General and Typography on wrapper selection
    hideGeneralAndTopographyForWrapper(editor);
  });

  let dragedComponentIsImage = false;

  editor.on("component:selected", (component) => {
    const tagNameForm = [
      "input",
      "textarea",
      "label",
      "button",
      "select",
      "form",
    ];

    if (component.is('image')) {
      
   
      const cmp = editor.getSelected();
      cmp.getEl().addEventListener('drop', (event) => {
        event.preventDefault();
        event.stopPropagation();
        const dt = event.dataTransfer;
        const json = dt.getData('application/json');
        if(!json) {
          dragedComponentIsImage = false;
          return;
        } else {
          dragedComponentIsImage = true;
        }
        let parsed;
        try {
          parsed = JSON.parse(json);
        } catch {
          dragedComponentIsImage = false;
          return;
        }
        const nextSrc =
          typeof parsed === "string"
            ? parsed
            : parsed?.componentUrl ||
              parsed?.imageProductionLink ||
              parsed?.link ||
              parsed?.src ||
              null;
        if (nextSrc && cmp) {
          cmp.set({ src: nextSrc, alt: "ImageName" });
          /* LHS used-state tracking for image placeholders: persist dragged content id + module/claim tags on the placeholder so isDataContentIdOnEditor/isContentIdUsedOnEditorOrDeck see this image as used. */
          if (parsed && typeof parsed === "object") {
            const attrPatch = {};
            if (parsed.dataContentId)
              attrPatch["data-content-id"] = parsed.dataContentId;
            if (parsed.moduleClaim)
              attrPatch["module-claim"] = parsed.moduleClaim;
            if (parsed.parentClaim)
              attrPatch["parent-claim"] = parsed.parentClaim;
            if (Object.keys(attrPatch).length) {
              try {
                if (typeof cmp.addAttributes === "function") {
                  cmp.addAttributes(attrPatch);
                } else {
                  cmp.set("attributes", {
                    ...(cmp.getAttributes?.() || {}),
                    ...attrPatch,
                  });
                }
              } catch (_) {
                /* ignore attribute set errors */
              }
            }
          }
          try {
            syncSelectedModuleUsedFromCanvas(editor, appData);
          } catch (_) {
            /* ignore */
          }
        }
      });
          if(component.attributes.tagName === "img") {
           setState(true)
           editor?.AssetManager?.open();

         
        } 
    }

    if (component.is('video')) {
      const cmp = editor.getSelected();
      if (!cmp) return;

      const el = cmp.getEl();
      if (!el) return;

      cmp.getEl().addEventListener('drop', (event) => {
        event.preventDefault();
        const dt = event.dataTransfer;
        const json = dt.getData('application/json');
        const videoData = JSON.parse(json);
        cmp.set({ src: videoData.link });
      });
    }

    
    trackDroppingComponent(component, setVideoSelected, setExpandLeft, setExpandRight, editor)

    //body tag doesn't have modular content toggle
    //hideModularContentForBodyTag(component);

    //Modular content toggle show for component 
    //modularContentToggleShow(component, tagNameForm, switchToggleDataRef, editor);
    //left blocks show rspect to comp
    leftPanelBlocksHideShow(editor, component, tagNameForm)

    //set image upload setion false/hide
    // setState(false);
    if (component.is('image')) {
     // setState(true);
      const pn = editor?.Panels;
      const traitBtn = pn?.getButton('views', 'open-tm');
      if(traitBtn && !traitBtn?.get('active')) {
        traitBtn?.set('active', true);
        pn?.trigger('change:active', traitBtn);
      }
    } else {
       if (editor?.AssetManager) {
      setState(false);
      editor?.AssetManager?.close();
    }
     // setState(false);
    }
    showSlidesPanel(false);

    //configs for comp selection respectively
    onCompSelectConfig(component, editor)

    // }
  });

  // table traits setting for preventing negative numbers for rows and columns
  tableConfig(editor);

  //video component default collapsed all properties
  videoConfig(editor)
  //end

  function getTraitsOptionsStructure(show, slideListName) {

    const { _id, name } = show.slideid;
    let ID = JSON.stringify(currentSlideRef?.current?.child) === "{}"
      ? currentSlideRef?.current?.master?.slideid?._id
      : currentSlideRef?.current?.child?.slideid?._id;
   
      const allIds = [];

      // const walk = (comps) => {
      //   comps.each((child) => {
      //     const id = child.getAttributes()?.id;
      //   //  console.log(child.get("type"), "here")
      //     if (id && child.get("type") === "custom-popup") {
      //       allIds.push(id); 
      //     }
      //     if (child.components().length) walk(child.components());
      //   });
      // };

      // walk(editor.DomComponents.getComponents());
      allIds.forEach((id) => {slideListName.push({ id, name: id })})
    if (ID !== _id)
      slideListName.push({ id: _id, name })
    if (ID === _id && show.children.length) {
      show.children.forEach((child) => {
        const { _id, name } = child.slideid;
        slideListName.push({ id: _id, name })
      })
    }
  }

  function isValidHttpUrl(string) {
    let url;
    try {
      url = new URL(string);
    } catch (_) {
      return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
  }

  const updateStyleManager = () => {
    const model = editor.getSelected();
    const sm = document.getElementsByClassName("gjs-sm-sectors")[0];
    sm.style.display = model?.attributes?.type === "wrapper" ? "none" : "block";
  };

  //Common trait for every component act as popup trigger
  defaultConfigForAllComp(editor)


  editor.on("component:remove:before", function (elem) {
    setVideoSelected(false);
    if (elem.attributes.tagName !== "body") {
      // after deleting comp redirect to block list comp
      if (appData.deckId.default_aspect_ratio !== selectedItem)
        setListOfID([...listOfIDRef.current, elem.ccid]);

      setState(false);
      //Removing comp should retain to default editor screen
      removeCompSettingRetainDefault(editor)

      //find dataId for popup modal reference to remove corresponding div while removing comp has link with subslide
      //delete linked modal if respective component deleted
      removePopupDivLinkedToComp(elem, editor)
    }
  });

  editor.on("component:selected", function (elem) {
    //change of video src trigger this function
    elem.on("change:src", function () {
      const attr = this?.attributes?.src;
      const availaleExtensions = ["mp4", "webm", "ogv"];
      const extn = attr?.split(".").reverse()[0];
      //const regx = /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/igm;
      if (
        this.attributes.provider === "so" &&
        availaleExtensions.includes(extn) &&
        this.attributes.type === "video"
      ) {
        if (isValidHttpUrl(attr)) {
        } else {
          showErrorToast('Please provide correct URL.');
        }
      } else if (this.attributes.provider === "yt") {
        // this.get("traits").where({ name: "videoId" })[0].set("value", "");
      } else if (this.attributes.provider === "ytnc") {
        // this.get("traits").where({ name: "videoId" })[0].set("value", "");
      } else if (this.attributes.provider === "vi") {
        // this.get("traits").where({ name: "videoId" })[0].set("value", "");
      } else {
        // if (attr !== "" && this.attributes.type === "video") {
        //   showErrorToast(`Please provide only 'mp4', 'webm' 'ogv' extensions`);
        // }
      }
    });
    //change of video provider trigger this function
    elem.on("change:provider", function () {
      if (this.attributes.provider === "so") {
        this.get("traits").where({ name: "controls" })[0].set("value", false);
        this.get("traits").where({ name: "controls" })[0].set("value", true);
      } else {
        /* setTimeout(() => {
          //this.get("traits").where({ name: "videoId" })[0].set("value", " ");
          this.get("traits").where({ name: "videoId" })[0].set("value", "");
        }, 500); */
        this.set({ videoId: "" });
      }
    });

    // binding event on link to selection
    elem.on("change:attributes:data-slide-id", function (val) {

      if (val?.attributes?.attributes["data-slide-id"] === 'null') {
        elem.removeAttributes("data-slide-id");
        return;
      }

      let valMaster = attachMasterSlide(elem, appData, editor, currentSlideRef, val?.attributes?.attributes["data-slide-id"])
      if (!valMaster) {
        return
      }
      //elem.removeTrait("href");
      const attrList = this.getAttributes();
      this.addAttributes({ ccid: this.ccid });
      const dataId =
        this.attributes.tagName === "img" ? this.ccid : attrList["id"];
      var ele = editor.getWrapper()?.find(`[data-id= ${dataId}]`);
      var bodyElem = editor.getWrapper();
      if (ele.length === 0) {
        bodyElem.append(`<div data-id='${dataId}' data-slide-id='${attrList["data-slide-id"]}' class="modal">
         <div class="modal-content">
         <span class="close"><button style="cursor:pointer">&times;</button></span>
         </div>
       </div>`);
      } else {
        var comp = editor.getComponents();
        comp.remove(ele);
        bodyElem.append(`<div data-id='${dataId}' data-slide-id='${attrList["data-slide-id"]}' class="modal">
         <div class="modal-content">
         <span class="close"><button style="cursor:pointer">&times;</button></span>
         </div>
       </div>`);
      }
    });

    // end binding linkto selection event

    const childrenList = currentSlideRef?.current?.master?.children?.length;
    if (
      elem.attributes.tagName !== "body" &&
      elem.attributes.name !== "Wrapper"
    ) {
      const childId = currentSlideRef.current.child?.slideid?._id
        ? currentSlideRef.current.child?.slideid?._id
        : "";
      // const slidesList = currentSlideRef.current.master.children.map(
      //   getTraitsOptionsStructure
      // );
      // const linkToList = slidesList.filter((list) => list.id !== childId);


      let linkToList = [{ id: null, name: 'No Link' }]
      appData.deckId.slides.forEach((show) => {

        getTraitsOptionsStructure(show, linkToList)
      });
      // redeclare trait again after removing
      if (
        elem.get("traits").where({ name: "data-slide-id" }).length === 0 &&
        elem.attributes.tagName !== "body"
      ) {
        if (
          elem.attributes.type !== "link"
          //&&
          // hrefLinked?.trim() !== "" &&
          // hrefLinked?.trim() !== undefined
          && elem.attributes.tagName !== "a" && elem.attributes.type !== "text"
          && elem.attributes.type !== "popup-close-button"
          && elem.attributes.type !== "popup-trigger-button"
        ) {
          elem.get("traits").add({
            type: "select",
            label: "Link To",
            name: "data-slide-id",
          });
        }
      }
      //
      if (elem.get("traits").where({ name: "data-slide-id" }).length > 0) {
        elem
          .get("traits")
          .where({ name: "data-slide-id" })[0]
          .set("options", linkToList);
      }
      //if slide doesn't have any children
      // if (childrenList === 0) {
      //   elem.removeTrait("data-slide-id");
      // }
      // if only one subslide is there then subslide should not show linkTo
      if (linkToList.length === 0) {
        elem.removeTrait("data-slide-id");
      }
      // link to should not be available to subslides
      if (
        childId !== "" &&
        childId !== currentSlideRef?.current?.master?.slideid._id
      ) {
        elem.removeTrait("data-slide-id");
      }
      elem.on("change:attributes:href", function (val) {
        const href = val.attributes?.attributes["href"];
        if (
          elem.attributes.type === "link"
          // &&
          // href?.trim() !== "" &&
          // href !== undefined
        ) {
          elem.removeTrait("data-slide-id");
        }
        if (
          elem.get("traits").where({ name: "data-slide-id" }).length === 0 &&
          (href === "" || href === undefined)
        ) {
          elem.addTrait({
            type: "select",
            label: "Link To",
            name: "data-slide-id",
            options: linkToList,
          });
        }
      });
    }
  });

  editor.on("component:selected", updateStyleManager);

  editor.on("component:clone", function (elem) {
    if (appData.deckId.default_aspect_ratio !== selectedItem)
      setListOfID([...listOfIDRef.current, elem.ccid]);
    // const attr = elem.getAttributes();

    /* const attr = elem.getAttributes();
    delete attr["data-slide-id"];
    delete attr["ccid"];
    elem.setAttributes(attr);
    elem.removeTrait("data-slide-id"); */

  });

  editor.on("component:update:attributes", updateStyleManager);

  /** Multi-dim decks only: mirror live project JSON into every dim_* + root editorData (keeps cssObj/css). */
  const syncResponsiveEditorData = () => {
    if (!appData?.deckId?.default_aspect_ratio || !editor?.getProjectData) return;
    setTimeout(() => {
      try {
        const pj = JSON.stringify(editor.getProjectData());
        const ref = storageObjRef.current;
        if (!ref) return;
        RESPONSIVE_DIM_KEYS.forEach((dim) => {
          const slot = ref[dim];
          ref[dim] =
            slot && typeof slot === "object"
              ? { ...slot, editorData: pj }
              : { editorData: pj, cssObj: [], css: "" };
        });
        ref.editorData = pj;
        if (typeof setStorageObj === "function") {
          setStorageObj({ ...ref });
        }
      } catch (_) {}
    }, 0);
  };

  // After undo/redo, GrapesJS restores the canvas, but component:remove:before prunes dim_* editorData. To retain the HTML,
  // we sync the data across all dimensions.
  const syncAllDimensionsFromRestore = (ed) => {
    if (!appData?.deckId?.default_aspect_ratio || !ed?.getProjectData) return;
    const ref = storageObjRef.current;
    if (!ref) return;
    let pj;
    try {
      pj = JSON.stringify(ed.getProjectData());
    } catch (_) {
      return;
    }
    RESPONSIVE_DIM_KEYS.forEach((dim) => {
      const slot = ref[dim];
      ref[dim] =
        slot && typeof slot === "object"
          ? { ...slot, editorData: pj }
          : { editorData: pj, cssObj: [], css: "" };
    });
    ref.editorData = pj;
    if (typeof setStorageObj === "function") {
      try {
        setStorageObj({ ...ref });
      } catch (_) {}
    }
  };

  editor.on('canvas:drop', (ev,component)=>{
      if (component && component.is("image")) {
        component.addStyle({
          "max-width": "100%",
          "max-height": "100%",
          "min-width": "100px",
          height: "auto",
          display: "block",
        });
      }
      else if (component && component.is("video")) {
        const el = component.getEl();
        if (el) {
          const parent = el.parentElement;
          const widthPx = parent?.getBoundingClientRect().width;

          component.addStyle({
            width: widthPx>300 ? "300px" : "100%",
            "max-width": "100%",
            "max-height": "100%",
            "min-width": "100px",
            height: "auto",
            display: "block",
          });
        }
        else {
          component.addStyle({
            width: "100%",
            "max-width": "100%",
            "max-height": "100%",
            height: "auto",
            display: "block",
          });
        }
      }
      else if (component && component.is("form")) {
        const el = component.getEl();
        if (el) {
          const parent = el.parentElement;
          const widthPx = parent?.getBoundingClientRect().width;

          component.addStyle({
            width: widthPx>220 ? "220px" : "90%",
            "max-width": "100%",
          });
        }
        else {
          component.addStyle({
            "width": "220px",
            "max-width": "100%",
          });
        }
        const applyToChildren = (comp) => {
          comp.components().forEach(child => {
            child.addStyle({
              "max-width": "100%",
            });

            // recursive
            applyToChildren(child);
          });
        };

        applyToChildren(component);
      }
      else if (component && component.attributes.type === "tabs") {
        const el = component.getEl();
        if (el) {
          const parent = el.parentElement;
          const widthPx = parent?.getBoundingClientRect().width;

          component.addStyle({
            width: widthPx>220 ? "220px" : "90%",
            "max-width": "100%",
          });
        }
        else {
          component.addStyle({
            "width": "220px",
            "max-width": "100%",
          });
        }
      }
      else if (component && component.parent().attributes.type === "form") {
        component.addStyle({
          "max-width": "100%",
        });
      }
      else if (component && component.is("custom-popup")) {
        const el = component.getEl();

        if (el && el.parentElement) {
          const parent = el.parentElement;
          const widthPx = parent.getBoundingClientRect().width;
          const heightPx = parent.getBoundingClientRect().height;

          let finalWidth = 300;
          let finalHeight = 300;
          if(component.parent().attributes.name !== "Cell" 
            && component.parent().attributes.type !== "Div") {
            finalWidth = Math.min(widthPx, Math.max(widthPx * 0.8, 300));
            finalHeight = Math.min(heightPx, Math.max(heightPx * 0.8, 300));
            component.addStyle({
              width: `${finalWidth}px`,
              height: `${finalHeight}px`,
            });
          }
          else {
            finalWidth = Math.min(widthPx, 600);
            finalHeight = finalWidth;
            component.addStyle({
              position: "relative",
              width: `${finalWidth}px`,
              height: `${finalHeight}px`,
            });
          }

          component.components().forEach(child => {
            child.addStyle({
              width: finalWidth>300 ? "300px" : "100%",
              height: finalHeight>300 ? "300px" : "100%",
            });
          });
        }
      }
      else if (component && component.is("popup-close-button")) {
        if(component.parent().is("custom-popup")) {
          component.addStyle({
            position: "absolute",
            top: "0",
            right: "0"
          });
        }
        else {
          component.addStyle({
            position: "static",
            top: "auto",
            right: "auto"
          });
        }
      }
      const position = component.getStyle().position;
      if(component.parent().attributes.name === "Cell" 
        || component.parent().attributes.type === "Div") {
        component.addStyle({
          "max-width": "100%",
          "word-break": "break-word",
          "overflow-wrap": "break-word",
          "white-space": "normal",
        })
      }

      // Position component at mouse cursor using translate
      if (
        // position === "absolute" &&
        // component && component.is("image") &&
        // !component.is("custom-popup") &&
        lastMousePos.x !== null && lastMousePos.y !== null 
        && component.parent().attributes.name !== "Cell"
        && component.parent().attributes.type !== "form"
        && component.parent().attributes.type !== "Div"
        && !component.parent().is("popup-trigger-button")
      ) {
        setTimeout(() => {
          try {
            const el = component.getEl && component.getEl();
            const frame = editor.Canvas && editor.Canvas.getFrameEl && editor.Canvas.getFrameEl();
            if (!el || !frame) return;

            const frameRect = frame.getBoundingClientRect();
            const cursorXInFrame = lastMousePos.x - frameRect.left;
            const cursorYInFrame = lastMousePos.y - frameRect.top;

            const parent = el.offsetParent || el.parentElement;
            if (!parent) return;
            const parentRect = parent.getBoundingClientRect();
            const parentLeftInFrame = parentRect.left - frameRect.left;
            const parentTopInFrame = parentRect.top - frameRect.top;

            // Calculate desired position relative to parent
            const desiredLeft = cursorXInFrame - parentLeftInFrame;
            const desiredTop = cursorYInFrame - parentTopInFrame;

            // Get current element position
            const currentLeft = el.offsetLeft || 0;
            const currentTop = el.offsetTop || 0;

            // Calculate translate delta
            const deltaX = desiredLeft - currentLeft;
            const deltaY = desiredTop - currentTop;

            // Get existing translate if any
            const computedStyle = window.getComputedStyle(el);
            const transform = computedStyle.transform;
            let baseTx = 0, baseTy = 0;
            
            if (transform && transform !== 'none') {
              const matrix = new DOMMatrix(transform);
              baseTx = matrix.e;
              baseTy = matrix.f;
            }

            // Ensure parent is positioned for absolute children
            const parentStyle = window.getComputedStyle(parent);
            if (parentStyle.position === 'static') {
              const parentModel = component.parent && component.parent();
              if (parentModel && parentModel.addStyle) {
                parentModel.addStyle({ position: 'relative' });
              }
            }

            // Apply new translate and set absolute to remove from flow (siblings won't move)
            const newTx = Math.round(baseTx + deltaX);
            const newTy = Math.round(baseTy + deltaY);
            component.addStyle({ 
              position: 'absolute',
              transform: `translate(${newTx}px, ${newTy}px)` 
            });
          } catch (_) {}
        }, 0);
      } 
      if (lastHoveredImagePlaceholder && dragedComponentIsImage ) {
        setTimeout(() => {
          const lastHoveredImagePlaceholderParent = lastHoveredImagePlaceholder.parent();
          if(lastHoveredImagePlaceholderParent.attributes.name === "Cell") {
            const el = lastHoveredImagePlaceholderParent.getEl();
            if (el.firstChild && el.firstChild.tagName === 'BR') {
              const firstChild = el.firstChild;
              if (
                firstChild.hasAttribute &&
                firstChild.hasAttribute('data-gjs-highlightable') &&
                firstChild.textContent.trim() === ''
              ) {
                firstChild.remove();
                setTimeout(() => {
                  // trigger save
                  editor.store();
                }, 1000);
              }
            }
          }
          const style = lastHoveredImagePlaceholder.getStyle();
          // console.log(style);
          delete style?.height;
          lastHoveredImagePlaceholder.setStyle({
            ...style,
            height: "auto",
          });
          // console.log(lastHoveredImagePlaceholder.getStyle());
          editor.select(lastHoveredImagePlaceholder);
          dragedComponentIsImage = false;
        }, 100);
      }
      if (component) {
        syncResponsiveEditorData();
      }
      requestAnimationFrame(() => refreshUndoRedoFromManager());
  })
  editor.on(`block:drag:stop`, (component, block) => {
    // if component exists, means the drop was successful
    // window.localStorage.setItem("drop", true);
    editor?.SelectorManager?.setState("");
    if (component) {
      // Since the comp inside the link was not getting highlighted, this is workaround
      // Do you need the parent who contains this new added component??

      if (component.parent().attributes.type === "link") {
        editor.select(component);

        if (component.attributes.type === "link") {
          component.parents().forEach((comp) => {
            if (comp.attributes.name === "Link Block") component.remove();
          });
          const structureBlock = document.querySelector(
            ".gjs-block-categories"
          ).firstChild;
          structureBlock?.classList.add("d-none");
          structureBlock?.classList.remove("d-block");
        }
      }

      window.localStorage.setItem("drop", false);
      // setState(false);
      editor.select(null);

      if (appData.deckId.default_aspect_ratio !== selectedItem && selectedItem)
        setListOfID([...listOfIDRef.current, component.ccid]);
      if (component.getName() === "tabs")
        setListOfID([...listOfIDRef.current, "tab", "tab-contents", "tab-container"]);

      syncResponsiveEditorData();

      requestAnimationFrame(() => refreshUndoRedoFromManager());
    }

    Flag = true;

  });

  EditorOnLoad({ editor, setVideoSelected, setUploadFont, appData, setOpenDocumentModal, setState, selectedItem, storageObjRef, currentSlideRef, codeEditor, setLoading, relatedClaimsDataRef });
  mustUseRemove({editor, appData});
  editor.Components.addType("Div", {
    isComponent: (el) => {
      return (
        el.tagName === "Div" &&
        el.getAttribute("data-gjs-type") === "Div" &&
        el.getAttribute("data-gjs-name") === "Div"
      );
    },

    extend: "default",

    model: {
      defaults: {
        tagName: "Div",
        removable: true,
        draggable: true,
        droppable: true,
        copyable: true,
        resizable: true,
      },
    },
  });


  editor.RichTextEditor.add("orderedList", {
    icon: "",
    attributes: { title: "Ordered List", class: "gjs-rte-action ordered-list" },
    result: (rte) => {
      const rteEl = editor.RichTextEditor.getToolbarEl();
      rteEl.firstChild.childNodes.forEach((child, idx) => { });
      rte.exec("insertOrderedList");
    },
  });

  editor.RichTextEditor.add("unorderedList", {
    icon: "",
    attributes: {
      title: "Unordered List",
      class: "gjs-rte-action unordered-list",
    },
    result: (rte) => rte.exec("insertUnorderedList"),
  });

  editor.RichTextEditor.add("superscript", {
    icon: "<b>S<sup>s</sup></b>",
    attributes: { title: "Superscript" },
    result: (rte) => rte.exec("superscript"),
  });

  editor.RichTextEditor.add("subscript", {
    icon: "<b>S<sub>s</sub></b>",
    attributes: { title: "Subscript" },
    result: (rte) => rte.exec("subscript"),
  });

  // editor.on("load", (elem) => {
  //   const allComponents = editor.DomComponents.getComponents();
  //   const formsFieldsBlock = document?.querySelector(".forms-field-block");
  //   const traverseComponents = components => {
  //     components.forEach(comp => {
  //       if (comp.is('form')) {
  //         formsFieldsBlock?.classList.add("form-fields-active");
  //       }
  //       else if (comp.components && comp.components().length) {
  //         traverseComponents(comp.components());
  //       }
  //     });
  //   };
  //   traverseComponents(allComponents);
  // });

  // editor.on("update", (elem) => {
  //   const allComponents = editor.DomComponents.getComponents();
  //   const formsFieldsBlock = document?.querySelector(".forms-field-block");
  //   const traverseComponents = components => {
  //     components.forEach(comp => {
  //       if (comp.is('form')) {
  //         formsFieldsBlock?.classList.add("form-fields-active");
  //       }
  //       else if (comp.components && comp.components().length) {
  //         traverseComponents(comp.components());
  //       }
  //     });
  //   };
  //   traverseComponents(allComponents);
  // });
  editor.DomComponents.addType('image', {
      model: {
        defaults: {
          tagName: 'img',
          attributes: { src: '' },
          // style: {
          //   width: '450px',
          //   height: '450px',
          //   maxWidth: 'auto',
          //   maxHeight: 'auto'
          // },

          resizable: false, // Default: not resizable until checkbox is checked
          lockAspectRatio: false,
          aspectRatio: null, // Will store the calculated aspect ratio

          traits: [
            {
              type: 'text',
              name: 'src',
              label: 'Image URL'
            },
            {
              type: 'checkbox',
              name: 'lockAspectRatio',
              // name: 'keepAspect',
              label: 'Lock Aspect Ratio',
              changeProp: 1
            }
          ],
        },

        init() {
          this.listenTo(this, 'change:lockAspectRatio', this.toggleResizable);
          this.listenTo(this, 'change:attributes:src', this.calculateAspectRatio);
          this.addLockIconToToolbar();
          
          // Calculate aspect ratio if src already exists
          const src = this.getAttributes().src;
          if (src) {
            this.calculateAspectRatio();
          }
        },

        calculateAspectRatio() {
          const src = this.getAttributes().src;
          if (!src) return;

          const img = new Image();
          img.onload = () => {
            const isLocked = this.get('lockAspectRatio');
            const aspectRatio = img.naturalWidth / img.naturalHeight;
            this.set('aspectRatio', aspectRatio);
            // If aspect ratio is locked, update resizable config
            if (this.get('lockAspectRatio')) {
              this.updateResizableConfig();
            }
              aspectRatioCheckBoxHandler(isLocked);
          };
          img.onerror = () => {
            // If image fails to load, try to get aspect ratio from element
            const el = this.getEl();
            if (el && el.naturalWidth && el.naturalHeight) {
              const aspectRatio = el.naturalWidth / el.naturalHeight;
              this.set('aspectRatio', aspectRatio);
            }
          };
          img.src = src;
        },

        updateResizableConfig() {
          const isLocked = this.get('lockAspectRatio');
          const aspectRatio = this.get('aspectRatio');

          if (isLocked && aspectRatio) {
            this.set('resizable', {
              tl: 1, tc: 0, tr: 1,
              cl: 0, cr: 0,
              bl: 1, bc: 0, br: 1,
              ratioDefault: true,
              ratio: aspectRatio
            });
          } else {
            this.set('resizable', {
              tl: 1, tc: 1, tr: 1,
              cl: 1, cr: 1,
              bl: 1, bc: 1, br: 1,
              ratioDefault: false
            });
          }
          // Update toolbar icon based on lock state
          aspectRatioCheckBoxHandler(isLocked);
        },

        addLockIconToToolbar() {
          const toolbar = this.get('toolbar') || [];
          const isLocked = this.get('lockAspectRatio');
          const hasLockIcon = toolbar.some(t => t.command === 'toggle-aspect');
        
          if (!hasLockIcon) {
            // Enable resizable if not locked
            if (!isLocked) {
              this.updateResizableConfig();
            } else {
              this.updateResizableConfig();
            }
            
            const lockBtn = {
              id: 'lock-btn',
              type: 'button',
              command: 'toggle-aspect',
              attributes: {
                class: 'gjs-toolbar-item',
                title: 'Lock Aspect Ratio'
              },
              label: isLocked
                ? `<img src="${LockIcon}" style="width:16px;height:16px;" />`
                : `<img src="${UnlockIcon}" style="width:16px;height:16px;" />`
            };

            this.set('toolbar', [lockBtn, ...toolbar]);
          }
        },
        toggleResizable() {
          const isLocked = this.get('lockAspectRatio');
          const toolbar = this.get('toolbar') || [];
          const updatedToolbar = toolbar.map(item => {
            if (item.command === 'toggle-aspect') {
              return {
                ...item,
                label: isLocked
                ? `<img src="${LockIcon}" style="width:16px;height:16px;" />`
                : `<img src="${UnlockIcon}" style="width:16px;height:16px;" />`
              };
            }
            return item;
          });
          this.set('toolbar', updatedToolbar);
          
          // Update resizable configuration
          this.updateResizableConfig();
        }
      }
    });

    editor.on('asset:add', (asset) => {
      setTimeout(() => {
        const selected = editor.getSelected();
        if (
          selected &&
          selected.is('image') &&
          !selected.getAttributes()['data-placeholder']
        ) {
          // Calculate aspect ratio when image is added
          if (selected.calculateAspectRatio) {
            selected.calculateAspectRatio();
          }
          
          selected.addStyle({
            width: 'auto',
            height: 'auto'
          });

          // Clean any fixed dimensions if they exist
          selected.removeStyle('width');
          selected.removeStyle('height');
        }
      }, 100);
    });
    
    // Command for toggling aspect ratio via toolbar button
    editor.Commands.add('toggle-aspect', {
      run(ed, sender) {
        const cmp = ed.getSelected();
        if (!cmp || !cmp.is('image')) return;
    
        const isLocked = !cmp.get('lockAspectRatio');
        cmp.set('lockAspectRatio', isLocked);
        
        // Update resizable configuration
        if (cmp.updateResizableConfig) {
          cmp.updateResizableConfig();
        }
        
        // Update button active state
        if (sender) {
          sender.set('active', isLocked);
        }
      }
    });

  editor.on("component:selected", (elem) => {
    const selected = editor.getSelected();
    opacityFieldRestrictDecimal();
    linkComponent(selected, elem);
    tableRowColumnDecimalRestriction(selected);
    symbolRestrictModify(selected)
    // Calculate aspect ratio when image is selected if it has a src
    if (selected && selected.is('image')) {
      const src = selected.getAttributes().src;
      if (src && selected.calculateAspectRatio) {
        selected.calculateAspectRatio();
      }
    }
  });
  
  // Maintain aspect ratio during resize
  editor.on('component:update', (component) => {
    if (component && component.is('image') && component.get('lockAspectRatio')) {
      const aspectRatio = component.get('aspectRatio');
      if (aspectRatio) {
        const el = component.getEl();
        if (el) {
          const currentWidth = parseFloat(el.style.width) || el.offsetWidth;
          const currentHeight = parseFloat(el.style.height) || el.offsetHeight;
          
          // If width changed, update height to maintain aspect ratio
          if (currentWidth && currentHeight) {
            const expectedHeight = currentWidth / aspectRatio;
            if (Math.abs(currentHeight - expectedHeight) > 1) {
              component.addStyle({ height: `${expectedHeight}px` });
            }
          }
        }
      }
    }
  });

  editor.on("component:selected", (elem) => {
    const selected = editor.getSelected();
    opacityFieldRestrictDecimal();
    linkComponent(selected, elem);
    tableRowColumnDecimalRestriction(selected);

  });

  editor.on("component:deselected", (component) => {
    //called on deselection of component, gets previous comp on selection of next comp
    callbackOnDeselectOfComp(component, setState, editor)
  });

  editor.on("component:remove:before", (component) => {
    if (!appData?.deckId?.default_aspect_ratio) return;
    if (!selectedItem || !cssRef.current || !storageObjRef.current) return;
    const tag = component.get?.("tagName");
    if (tag === "body" || component.is?.("wrapper")) return;

    const idsToRemove = collectRemovalIdsSet(component);
    if (!idsToRemove.size) return;

    const allDimensions = Object.fromEntries(
      Object.entries(cssRef.current).map(([dim, dimObj]) => [
        dim,
        Array.isArray(dimObj)
          ? dimObj.filter((element) => !idsToRemove.has(String(element.id)))
          : dimObj,
      ]),
    );

    const ref = storageObjRef.current;
    RESPONSIVE_DIM_KEYS.forEach((dim) => {
      const slot = ref[dim];
      if (!slot || typeof slot !== "object") return;
      const cssObj = (Array.isArray(slot.cssObj) ? slot.cssObj : []).filter(
        (el) => !idsToRemove.has(String(el.id)),
      );
      const rowsForDim = Array.isArray(allDimensions[dim])
        ? allDimensions[dim]
        : cssObj;
      ref[dim] = {
        ...slot,
        cssObj,
        editorData:
          typeof slot.editorData === "string"
            ? pruneEditorDataString(slot.editorData, idsToRemove)
            : slot.editorData,
        css: buildDimensionCssString(dim, rowsForDim),
      };
    });

    if (typeof ref.editorData === "string") {
      ref.editorData = pruneEditorDataString(ref.editorData, idsToRemove);
    }

    setCSSState(allDimensions);
    cssRef.current = allDimensions;

    scheduleStorageObjSyncAfterRemoval();
  });
 


  return editor;
}
// const updateModularContenforMM = (editor, ID) => {
//   const modBlockIndex = editor?.getWrapper()?.find("[modularBlockIndex]")?.length;
//   const modBlockRef = editor
//     ?.getWrapper()
//     .find("[modularblock=reference]").length;

//   const ModuleArray = [
//     "Module_A",
//     "Module_B",
//     "Module_C",
//     "Module_D",
//     "Module_E",
//     "Module_F",
//     "Module_G",
//   ];

//   ModuleArray.length = modBlockIndex;
//   if (modBlockRef > 0) {
//     ModuleArray.push("Module_Ref");
//   }

//   // if ( JSON.stringify(appData.) === JSON.stringify(ModuleArray))
//   // return;
//   updatSlideData(
//     ID,
//     { modules_tags: ModuleArray },
//     (response, err, errorCode) => {
//       if (err) {
//       } else {
//       }
//     }
//   );
// };

const RESPONSIVE_DIM_KEYS = [
  "dim_1024*768",
  "dim_2752*2064",
  "dim_2388*1668",
  "dim_2048*1536",
];

function getCssStorageId(component) {
  if (!component) return "";
  const attrId = component.getAttributes?.()?.id;
  if (attrId) return String(attrId);
  if (component.ccid != null) return String(component.ccid);
  return "";
}

function resolveStyleManagerPropKey(smProperty) {
  if (!smProperty) return "";
  const fromAttr = smProperty.attributes?.property;
  if (fromAttr) return fromAttr;
  if (typeof smProperty.get === "function") {
    const v = smProperty.get("property");
    if (v) return v;
  }
  if (typeof smProperty.getId === "function") {
    const gid = smProperty.getId();
    if (gid) return gid;
  }
  return smProperty.id || "";
}

function getSelectedComponentsForCssSync(editor) {
  if (!editor) return [];
  const isCssSyncTarget = (m) =>
    m &&
    m.getStyle &&
    !(typeof m.is === "function" && m.is("wrapper")) &&
    m.attributes?.type !== "wrapper";
  const all =
    typeof editor.getSelectedAll === "function"
      ? editor.getSelectedAll()
      : [];
  const list = Array.isArray(all) && all.length ? all : [];
  if (list.length) return list.filter(isCssSyncTarget);
  const one = editor.getSelected?.();
  return isCssSyncTarget(one) ? [one] : [];
}

function collectRemovalIdsSet(component) {
  const ids = new Set();
  const visit = (node) => {
    if (!node) return;
    if (node.ccid != null) ids.add(String(node.ccid));
    const aid = node.getAttributes?.()?.id;
    if (aid) ids.add(String(aid));
    const ch = node.components?.();
    if (ch && typeof ch.forEach === "function") ch.forEach(visit);
  };
  visit(component);
  return ids;
}

function buildDimensionCssString(dim, rows) {
  if (!dim || !Array.isArray(rows)) return "";
  let cssString = "";
  rows.forEach((obj) => {
    const sortedObj = sortCSSObject(obj);
    let idName = "";
    let properties = "";
    for (const [key, value] of sortedObj) {
      if (key === "id") {
        idName = "#" + obj[key];
      } else if (key === "flex" && obj[key] === "0 0 auto") {
        properties += `flex: 1 1 100%;`;
      } else {
        properties += `${key}: ${value};`;
      }
    }
    if (idName) {
      cssString += `${idName} { ${properties} } `;
    }
  });
  const hasWrapperCSS = /#wrapper\s*\{[^}]*\}/i.test(cssString);
  if (!hasWrapperCSS && dim) {
    const sizePart = dim.replace("dim_", "");
    const [width, height] = sizePart.split("*");
    if (width && height) {
      cssString += ` #wrapper { width: ${width}px; height: ${height}px } `;
    }
  }
  return cssString;
}

function styleRuleTargetsDeleted(style, idsSet) {
  if (!style || typeof style !== "object") return false;
  const sels = style.selectors;
  if (Array.isArray(sels) && sels.length) {
    const sel = sels[0];
    const name =
      typeof sel === "object" && sel
        ? sel.name
        : typeof sel === "string"
          ? sel
          : "";
    if (name) {
      const n = String(name).replace(/^#/, "");
      if (idsSet.has(n) || idsSet.has(String(name))) return true;
    }
  }
  if (style.selectorsAdd && typeof style.selectorsAdd === "string") {
    const add = style.selectorsAdd;
    for (const id of idsSet) {
      if (!id) continue;
      if (
        add === `#${id}` ||
        add.includes(`#${id}{`) ||
        add.includes(`#${id} {`)
      )
        return true;
    }
  }
  return false;
}

function pruneComponentsArray(components, idsSet) {
  if (!Array.isArray(components)) return components;
  return components
    .filter((comp) => {
      if (!comp || typeof comp !== "object") return true;
      const cid = comp.ccid != null ? String(comp.ccid) : "";
      const aid =
        comp.attributes?.id != null ? String(comp.attributes.id) : "";
      if (cid && idsSet.has(cid)) return false;
      if (aid && idsSet.has(aid)) return false;
      return true;
    })
    .map((comp) => {
      if (comp.components) {
        return {
          ...comp,
          components: pruneComponentsArray(comp.components, idsSet),
        };
      }
      return comp;
    });
}

function pruneEditorDataString(editorDataStr, idsSet) {
  if (!editorDataStr || typeof editorDataStr !== "string") return editorDataStr;
  try {
    const parsed = JSON.parse(editorDataStr);
    if (parsed != null && typeof parsed === "object") {
      if (Array.isArray(parsed.styles)) {
        parsed.styles = parsed.styles.filter(
          (s) => !styleRuleTargetsDeleted(s, idsSet),
        );
      }
      const root = parsed.pages?.[0]?.frames?.[0]?.component;
      if (root && Array.isArray(root.components)) {
        root.components = pruneComponentsArray(root.components, idsSet);
      }
    }
    return JSON.stringify(parsed);
  } catch {
    return editorDataStr;
  }
}

const CSS_ORDER = [
  "display",
  "position",

  "flex",
  "flex-grow",
  "flex-shrink",
  "flex-basis",

  "width",
  "height",
  "min-height",

  "color",
  "background"
];

function sortCSSObject(obj) {
  return Object.entries(obj).sort(([a], [b]) => {
    const ai = CSS_ORDER.indexOf(a);
    const bi = CSS_ORDER.indexOf(b);

    return (ai === -1 ? 9999 : ai) - (bi === -1 ? 9999 : bi);
  });
}

const constructCSS = (cssRef, dim, editor) => {

  let cssString = "";
  [...cssRef.current[dim]].forEach((obj) => {
    // arrange in order
    const sortedObj = sortCSSObject(obj);
    let idName = "";
    let properties = "";
    for (const [key, value] of sortedObj) {
      if (key === "id") {
        idName = "#" + obj[key];
      } else if (key === "flex" && obj[key] === "0 0 auto") {
        properties += `flex: 1 1 100%;`;
      } else {
        properties += `${key}: ${obj[key]};`;
      }
    }
    if (idName) {
      cssString += `${idName} { ${properties} } `;
    }
  });
  const hasWrapperCSS = /#wrapper\s*\{[^}]*\}/i.test(cssString);
  if(!hasWrapperCSS && dim) {
    const sizePart = dim.replace("dim_", "");
    const [width, height] = sizePart.split("*");
    if(width && height) {
      cssString += ` #wrapper { width: ${width}px; height: ${height}px } `;
    }
  }
  return cssString;
}

const savingResponsiveData = ({ storageObjRef, appData, selectedItem, cssRef, editor, data, setStorageObj }) => {
  if (!storageObjRef.current) {
    return data
  }
  let content = {};
  let defaultCSS = appData.deckId.default_aspect_ratio === selectedItem ? editor?.getCss() : storageObjRef?.current?.css;
  let LocalEditorData = appData.deckId.default_aspect_ratio === selectedItem ? JSON.stringify(data) : (storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData) ? storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData : "";
  content = {
    ...storageObjRef.current,
    default_ratio: appData.deckId.default_aspect_ratio,
    [selectedItem]: {
      editorData: JSON.stringify(data),
      // Preserve existing CSS data if cssRef is empty but storageObj has data
      cssObj: (() => {
        const cssRefData = cssRef.current[selectedItem];
        const storageData = storageObjRef.current && storageObjRef.current[selectedItem]?.cssObj;
        
        // console.log(`CSS Save Debug for ${selectedItem}:`, {
        //   cssRefHasData: cssRefData && cssRefData.length > 0,
        //   cssRefLength: cssRefData ? cssRefData.length : 0,
        //   storageHasData: !!storageData,
        //   storageLength: storageData ? storageData.length : 0
        // });
        
        if (cssRefData && cssRefData.length > 0) {
          // console.log("Using cssRef data");
          return cssRefData;
        } else if (storageData && storageData.length > 0) {
          // console.log("Using storage data as fallback");
          return storageData;
        } else {
          // console.log("No CSS data available, using empty array");
          return [];
        }
      })(),
      css: `${constructCSS(cssRef, selectedItem, editor)}`
      //  ratio_css: cssRef.current[dim]

    },
    //editorData: storageObjRef.current[appData.deckId.default_aspect_ratio]?.editorData|| JSON.stringify(data) ||"",
    editorData: LocalEditorData,
    html: editor?.getHtml() || "",
    css: `@import url('https://fonts.googleapis.com/css2?family=Lato:ital,wght@0,100;0,300;0,400;0,700;0,900;1,100;1,300;1,400;1,700;1,900&family=Montserrat:ital,wght@0,100..900;1,100..900&family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap');
${defaultCSS}`,
    extraContent:getPopUp(editor),

    // components: editor.getComponents() || "",
    // styles: editor.getStyle() || "",
    scripts: script,
      // editor?.getWrapper()?.find("[ccid]").length > 0
      //   ? script
      //   : mandatScript,
    thirdPartyPlugins: thirdPartyPlugins,

    //modalBgColor: editor.getWrapper().getStyle()["background-color"],
  };

  return content;
}

const getPopUp =(editor) =>{
    const allPopups = [];
    editor?.getWrapper()?.findType('custom-popup')?.forEach(comp => {
      const compId = comp?.ccid;
      allPopups.push({html:(comp.toHTML()), id: compId});
      // allPopups.push(comp.toHTML());
    });
  return allPopups;
}
export default getGrapeJsEditor;
